import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProfileState {
  lastName: string;
  firstName: string;
  email: string;
  phone: string;
  isEditing: boolean;
}

const initialState: ProfileState = {
  lastName: '',
  firstName: '',
  email: '',
  phone: '',
  isEditing: false,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile(state, action: PayloadAction<{ firstName: string; lastName: string; email: string; phone: string }>) {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.email = action.payload.email;
      state.phone = action.payload.phone;
    },
    setEditing(state, action: PayloadAction<boolean>) {
      state.isEditing = action.payload;
    },
    updateField(state, action: PayloadAction<{ field: keyof ProfileState; value: string }>) {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },
  },
});

export const { setProfile, setEditing, updateField } = profileSlice.actions;
export default profileSlice.reducer;
